<template>
  <div class="add-member-from-email">
    <dg-input type="text" v-model="email" placeholder="User e-mail"/>
    <el-button type="primary" icon="el-icon-message" @click="sendInvite">Send invitation</el-button>
  </div>
</template>

<script>
export default {
  name: 'InviteMemberDialog',
  data () {
    return {
      email: ''
    }
  },
  methods: {
    async sendInvite () {
      const data = { pending: true, invite: true, userEmail: this.email }
      const response = await this.$http.post(this.$api.organization(this.$route.params.orgId).users.create, data)
      
      this.$message.success(`An invite has been sent to ${this.email}`)
      this.$emit('sent', response.data)
      this.email = ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-member-from-email {
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-end;

    .el-input {
      width: 100% !important;
    }

    button {
      width: 100%;
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/Members/InviteMemberDialog.vue